<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="PDM销售排行榜"></chart-title>
    <div id="center_5">
      <date-change-card
        height="50%"
        @leftClick="leftClick"
        @rightClick="rightClick"
      >
        <div id="center_5_top" slot="main" />
      </date-change-card>
      <date-change-card
        height="50%"
        @leftClick="leftClick"
        @rightClick="rightClick"
      >
        <div id="center_5_bottom" slot="main" />
      </date-change-card>
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_5",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chartTop: null,
      chartBottom: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chartTop && !this.chartBottom) {
      return;
    }
    this.chartTop.dispose();
    this.chartTop = null;
    this.chartBottom.dispose();
    this.chartBottom = null;
  },
  methods: {
    initChart() {
      this.chartTop = this.$echarts.init(
        document.getElementById("center_5_top")
      );
      this.setOptions();
      this.chartBottom = this.$echarts.init(
        document.getElementById("center_5_bottom")
      );
      this.setOptionsBottom();
    },
    setOptions() {
      const color = ["59,157,255", "34,228,255", "59,255,208", "4,227,138"];
      let chartData = [
        { value: 498 },
        { value: 428 },
        { value: 400 },
        { value: 322 },
        { value: 463 },
        { value: 321 },
      ];
      chartData = chartData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: `rgba(${color[i % 4]},1)`,
              },
              {
                offset: 1,
                color: `rgba(${color[i % 4]},0.1)`,
              },
            ]),
          },
        };
      });
      this.chartTop.setOption({
        title: {
          subtext: "片区销售精英榜",
          left: "center",
          top: "3%",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "8%",
          right: "8%",
          top: "17%",
          bottom: "18%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: ["销售6", "销售5", "销售4", "销售3", "销售2", "销售1"],
        },
        series: [
          {
            name: "销售额（万）",
            type: "bar",
            data: chartData,
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
          },
        ],
      });
    },
    setOptionsBottom() {
      let chartData = [
        { value: 398 },
        { value: 198 },
        { value: 298 },
        { value: 300 },
        { value: 128 },
        { value: 328 },
        { value: 248 },
        { value: 178 },
        { value: 228 },
        { value: 398 },
      ];
      const color = ["0, 157, 255", "34, 228, 255", "59, 255, 208"];
      chartData = chartData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
              { offset: 0, color: `rgba(${color[i % 3]},0.1)` },
              { offset: 1, color: `rgba(${color[i % 3]},1)` },
            ]),
          },
        };
      });
      this.chartBottom.setOption({
        title: {
          subtext: "商家销售英雄榜",
          left: "center",
          top: "3%",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "8%",
          right: "8%",
          top: "17%",
          bottom: "10%",
          containLabel: true,
        },
        legend: {
          show: false,
          data: ["销售额（万）"],
          bottom: "bottom",
          textStyle: {
            color: "#606266",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: [
              "商家1",
              "商家2",
              "商家3",
              "商家4",
              "商家5",
              "商家6",
              "商家7",
              "商家8",
              "商家9",
              "商家10",
            ],
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "销售额（万）",
            type: "bar",
            data: chartData,
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 60vh;
  #center_5 {
    height: calc(100% - 30px);
    #center_5_top,
    #center_5_bottom {
      height: 100%;
    }
  }
}
</style>
